import React, {useState} from 'react';
import {getRelators} from '../providers/relator';
import {getRelators2} from '../providers/relator2';
import {Button} from "react-bootstrap";

const Team = () => {
    const relator = getRelators()
    const relator2 = getRelators2()
    const [showRelator, setShowRelator] = useState(false);
    return (
        <>
            <div className='px-4 mx-auto sm:max-w-xl md:max-w-full md:px-24 lg:px-8 bg-gris_rancagua mt-12' id='expositores'>
                <div className='px-4 py-16 mx-auto sm:max-w-xl md:max-w-full lg:max-w-screen-xl md:px-24 lg:px-8 lg:py-20 -mt-20'>
                    <div className='max-w-xl mb-10 md:mx-auto sm:text-center lg:max-w-2xl md:mb-12'>
                        <h2 className='max-w-lg mb-6 font-sans text-3xl font-bold leading-none tracking-tight text-gray-900 sm:text-4xl md:mx-auto'>
                          <span className='relative inline-block'>
                            <span className='relative text-white'>RELATORES</span>
                          </span>{' '}
                        </h2>
                    </div>
                    <div className='grid gap-10 sm:grid-cols-2 lg:grid-cols-4'>
                        {relator.map(({ src = '', alt = '', name = '', description='', flag=''}, key) => (
                        <div>
                            <div className=' rounded-xl relative overflow-hidden transition duration-300 transform rounded shadow-lg lg:hover:-translate-y-2 hover:shadow-2xl'>
                                <img
                                    className='object-cover w-full h-56 md:h-64 xl:h-64'
                                    src={src}
                                    alt={alt}
                                />
                                <div className='absolute inset-0 flex flex-col justify-center px-5 py-4 text-center transition-opacity duration-300 bg-black bg-opacity-75 opacity-0 hover:opacity-100'>
                                    <p className='mb-1 text-lg font-bold text-gray-100'>
                                        {name}
                                    </p>
                                    <p className='mb-4 text-xs tracking-wide text-gray-400'>
                                        {description}
                                    </p>
                                    <div className='flex items-center justify-center space-x-3'>
                                        {/*
                                        <a
                                            href='/'
                                            className='text-white transition-colors duration-300 hover:text-teal-accent-400'
                                        >
                                            <BsLinkedin className='h-5'/>
                                        </a>
                                        */}
                                    </div>
                                </div>
                            </div>
                            <div className='flex flex-col justify-center mt-2'>
                                <p className='text-lg font-bold text-white'>{name}</p>
                                <div className='border-b-2 border-white'/>
                                <div className='inline-flex text-left'>
                                    <img src={flag} alt={alt} className='w-14 h-14' />
                                    <p className='text-sm tracking-wide text-white ml-2'>
                                        {description}
                                    </p>
                                </div>
                            </div>
                        </div>
                        ))}
                    </div>


                    <div className='mt-5'>
                        {showRelator && (
                            <div className='grid gap-10 sm:grid-cols-2 lg:grid-cols-4'>
                                {relator2.map(({ src = '', alt = '', name = '', description='', flag=''}, key) => (
                                    <div>
                                        <div className='relative overflow-hidden transition duration-300 transform rounded shadow-lg lg:hover:-translate-y-2 hover:shadow-2xl'>
                                            <img
                                                className='object-cover w-full h-56 md:h-64 xl:h-64'
                                                src={src}
                                                alt={alt}
                                            />
                                            <div className='absolute inset-0 flex flex-col justify-center px-5 py-4 text-center transition-opacity duration-300 bg-black bg-opacity-75 opacity-0 hover:opacity-100'>
                                                <p className='mb-1 text-lg font-bold text-gray-100'>
                                                    {name}
                                                </p>
                                                <p className='mb-4 text-xs tracking-wide text-gray-400'>
                                                    {description}
                                                </p>
                                                <div className='flex items-center justify-center space-x-3'>
                                                    {/*
                                                    <a
                                                        href='/'
                                                        className='text-white transition-colors duration-300 hover:text-teal-accent-400'
                                                    >
                                                        <BsLinkedin className='h-5'/>
                                                    </a>
                                                    */}
                                                </div>
                                            </div>
                                        </div>
                                        <div className='flex flex-col justify-center mt-2'>
                                            <p className='text-lg font-bold text-white'>{name}</p>
                                            <div className='border-b-2 border-white'/>
                                            <div className='inline-flex text-left'>
                                                <img src={flag} alt={alt} className='w-14 h-14' />
                                                <p className='text-sm tracking-wide text-white ml-2'>
                                                    {description.split('\n')}
                                                </p>
                                            </div>
                                        </div>
                                    </div>
                                ))}
                            </div>
                        )}
                        <Button
                            className="hover:bg-celeste_rancagua lg:px-52 px-4 py-4 font-medium text-2xl tracking-wide text-white capitalize transition-colors duration-300 transform bg-morado_rancagua rounded-lg mt-10"
                            onClick={() => setShowRelator(!showRelator)}
                        >
                            {showRelator ? 'MOSTRAR MENOS' : 'MOSTRAR TODOS'}
                        </Button>
                    </div>




                    <div className='px-4 py-16 mx-auto sm:max-w-xl md:max-w-full lg:max-w-screen-xl md:px-24 lg:px-8 lg:py-20'>
                        <div className='max-w-xl mb-10 md:mx-auto sm:text-center lg:max-w-2xl md:mb-12'>

                            <h2 className='max-w-lg mb-6 font-sans text-3xl font-bold leading-none tracking-tight text-gray-900 sm:text-4xl md:mx-auto text-white'>
                                ¡MÁS DE 25 ESPECIALISTAS!
                            </h2>
                        </div>
                        {/* BANDERAS */}
                        <div className='grid max-w-screen-lg gap-8 row-gap-5 grid-cols-3 md:grid-cols-6 sm:mx-auto -mb-20 -mt-10'>
                            <img
                                className='md:w-full md:h-56 rounded md:mt-0 mt-5'
                                src='/assets/banderas/chile.svg'
                                alt=''
                            />
                            <img
                                className=' md:w-full md:h-56 rounded md:mt-0 mt-5'
                                src='/assets/banderas/colombia.svg'
                                alt=''
                            />
                            <img
                                className='md:w-full md:h-56  rounded md:mt-0 mt-5'
                                src='/assets/banderas/peru.svg'
                                alt=''
                            />
                            <img
                                className='md:w-full md:h-56  rounded md:mt-0 mt-5'
                                src='/assets/banderas/argentina.svg'
                                alt=''
                            />
                            <img
                                className='md:w-full md:h-56  rounded md:mt-0 mt-5'
                                src='/assets/banderas/ecuador.svg'
                                alt=''
                            />
                            <img
                                className='md:w-full md:h-56  rounded md:mt-0 mt-5'
                                src='/assets/banderas/espana.svg'
                                alt=''
                            />
                        </div>
                    </div>
                </div>
            </div>
        </>
    );
};

export default Team;